import { render, staticRenderFns } from "./stroeStaffMangement.vue?vue&type=template&id=a566725a&scoped=true&"
import script from "./stroeStaffMangement.vue?vue&type=script&lang=js&"
export * from "./stroeStaffMangement.vue?vue&type=script&lang=js&"
import style0 from "./stroeStaffMangement.vue?vue&type=style&index=0&id=a566725a&prod&lang=stylus&scoped=true&"
import style1 from "./stroeStaffMangement.vue?vue&type=style&index=1&id=a566725a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a566725a",
  null
  
)

export default component.exports